/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import styled from "styled-components"
import Header from "../components/header"

// Import typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'


let primary = "26A0A6"

const IndexHeader = ({location}) => {
  const data = useStaticQuery(graphql`
    query IHQuery {
      site {
        siteMetadata {
          title
          author {
            name
            summary
          }
          social {
            twitter
          }
        }
      }
    }
  `)

  const target = React.createRef();
  const path = typeof location === 'undefined' ? "" : location.pathname
  // Set these values by editing "siteMetadata" in gatsby-config.js
  const author = data.site.siteMetadata?.author
  const social = data.site.siteMetadata?.social
  const title = data.site.siteMetadata?.title

  return (
    <>
      <Wrapper>
        <TitleBox>
          <SiteTitle>{title}</SiteTitle>
        </TitleBox>
        <IntroWrapper as={Container}>
          <Details>
            {author?.name && (
              <BioTitle>
                Hi I'm <strong>{author.name}</strong>!
              </BioTitle>
            )}

            <BioPara>
            I'm a Mom of 3 that spends a lot of time at the beach.
            I write a <strong><Link to="/blog">blog</Link></strong> about living at the beach in a second house.
            I also help people <strong><a href="https://roombyroom.app/">organize their homes.</a></strong>
            </BioPara>

          </Details>
          <div>
            <RoundContainer>
              <StaticImage
                className="bio-avatar"
                layout="constrained"
                formats={["auto", "webp", "avif"]}
                src="../images/profile.png"
                width={256}
                height={256}
                quality={95}
                style={{minWidth: "96px"}}
                alt="Hi!"
              />
            </RoundContainer>
          </div>
        </IntroWrapper>
      </Wrapper>
    </>
  )
}



const SiteTitle = styled.h2`
  padding-top: 0rem;
  padding-bottom: 1rem;
  font-family: var(--sansSerif);
  font-weight: 600;
  color: var(--secondary);
`;

const TitleBox = styled.div`
  width: 80%;
  max-width: 1280px;
  display: flex;
  align-items: center;
  margin: 0 auto;
`;

const NavTitle = styled.p`
  font-size: var(--fontSize-7);
  font-family: var(--sansSerif);
  margin: 0;
`;


const Container = styled.div`
	max-width: 1280px;
	margin: 0 auto;
	width: 90%;

	@media (min-width: 601px) {
		width: 90%;
	}

	@media (min-width: 993px) {
		width: 65%;
	}
`;

export const Wrapper = styled.header`
  padding-bottom: 1rem;
  margin-top: 3rem;
background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='2200' height='240' preserveAspectRatio='none' viewBox='0 0 2200 240'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1007%26quot%3b)' fill='none'%3e%3cpath d='M -484.1044507436834%2c102 C -396.1%2c117 -220.1%2c189.8 -44.10445074368339%2c177 C 131.9%2c164.2 219.9%2c34.4 395.8955492563166%2c38 C 571.9%2c41.6 659.9%2c179.4 835.8955492563166%2c195 C 1011.9%2c210.6 1099.9%2c119.8 1275.8955492563166%2c116 C 1451.9%2c112.2 1539.9%2c183.6 1715.8955492563166%2c176 C 1891.9%2c168.4 2059.07%2c83 2155.895549256317%2c78 C 2252.72%2c73 2191.18%2c136.4 2200%2c151' stroke='rgba(113%2c 14%2c 62%2c 0.2)' stroke-width='2'%3e%3c/path%3e%3cpath d='M -45.94845487470576%2c137 C 42.05%2c129.8 218.05%2c90.4 394.05154512529424%2c101 C 570.05%2c111.6 658.05%2c197.2 834.0515451252943%2c190 C 1010.05%2c182.8 1098.05%2c70 1274.0515451252943%2c65 C 1450.05%2c60 1538.05%2c159.6 1714.0515451252943%2c165 C 1890.05%2c170.4 1978.05%2c89.6 2154.051545125294%2c92 C 2330.05%2c94.4 2584.86%2c190 2594.051545125294%2c177 C 2603.24%2c164 2278.81%2c57 2200%2c27' stroke='rgba(245%2c 20%2c 129%2c 0.23)' stroke-width='2'%3e%3c/path%3e%3cpath d='M -173.37508467315337%2c203 C -85.38%2c173.8 90.62%2c72.8 266.62491532684663%2c57 C 442.62%2c41.2 530.62%2c115.6 706.6249153268466%2c124 C 882.62%2c132.4 970.62%2c93.8 1146.6249153268466%2c99 C 1322.62%2c104.2 1410.62%2c146.6 1586.6249153268466%2c150 C 1762.62%2c153.4 1850.62%2c118.4 2026.6249153268466%2c116 C 2202.62%2c113.6 2431.95%2c148.2 2466.624915326847%2c138 C 2501.3%2c127.8 2253.32%2c79.6 2200%2c65' stroke='rgba(113%2c 14%2c 62%2c 0.2)' stroke-width='2'%3e%3c/path%3e%3cpath d='M -358.0692329012519%2c111 C -270.07%2c126 -94.07%2c188 81.9307670987481%2c186 C 257.93%2c184 345.93%2c106.6 521.9307670987481%2c101 C 697.93%2c95.4 785.93%2c158.2 961.9307670987481%2c158 C 1137.93%2c157.8 1225.93%2c107.4 1401.9307670987482%2c100 C 1577.93%2c92.6 1665.93%2c131.6 1841.9307670987482%2c121 C 2017.93%2c110.4 2210.32%2c43.2 2281.930767098748%2c47 C 2353.54%2c50.8 2216.39%2c121.4 2200%2c140' stroke='rgba(245%2c 20%2c 129%2c 0.23)' stroke-width='2'%3e%3c/path%3e%3cpath d='M -5.163410189846786%2c153 C 82.84%2c136.6 258.84%2c75.6 434.8365898101532%2c71 C 610.84%2c66.4 698.84%2c122.8 874.8365898101532%2c130 C 1050.84%2c137.2 1138.84%2c95.4 1314.8365898101533%2c107 C 1490.84%2c118.6 1578.84%2c190.8 1754.8365898101533%2c188 C 1930.84%2c185.2 2018.84%2c90.2 2194.8365898101533%2c93 C 2370.84%2c95.8 2633.8%2c205.2 2634.8365898101533%2c202 C 2635.87%2c198.8 2286.97%2c102 2200%2c77' stroke='rgba(113%2c 14%2c 62%2c 0.2)' stroke-width='2'%3e%3c/path%3e%3cpath d='M -564.372090487054%2c175 C -476.37%2c159.2 -300.37%2c92 -124.37209048705404%2c96 C 51.63%2c100 139.63%2c208.2 315.62790951294596%2c195 C 491.63%2c181.8 579.63%2c44.8 755.627909512946%2c30 C 931.63%2c15.2 1019.63%2c106.2 1195.627909512946%2c121 C 1371.63%2c135.8 1459.63%2c101.2 1635.627909512946%2c104 C 1811.63%2c106.8 1962.75%2c140 2075.6279095129457%2c135 C 2188.5%2c130 2175.13%2c90.2 2200%2c79' stroke='rgba(113%2c 14%2c 62%2c 0.2)' stroke-width='2'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1007'%3e%3crect width='2200' height='240' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e");  background-size: auto;
  background-repeat: no-repeat;
`;

export const IntroWrapper = styled.div`
  padding: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

export const Details = styled.div`
  flex: 1;
  padding-top: 6rem;
  @media (max-width: 960px) {
    width: 90%;
    margin-bottom: 2rem;
  }
  max-width: 480px;

  h1 {
    margin-bottom: 2rem;
    font-size: 36pt;
    color: #212121;

    @media (max-width: 680px) {
      font-size: 30pt;
    }
  }

  h4 {
    margin-bottom: 2.5rem;
    font-size: 32pt;
    font-weight: normal;
    color: #707070;

    @media (max-width: 680px) {
      font-size: 26pt;
    }
  }
`;

const BioPara = styled.div`
  margin-top: 1rem;
  line-height: 1.5;
  font-size: var(--size-400);
  color: var(--dark);

  a {
    text-decoration: underline;
    color: var(--secondary);
  }

  ul {
    margin: 0.2rem;
    line-height: 1;
  }

  li {
    margin: 0;
    line-height: 1.2rem;
    padding: 0.2rem;
  }
`;

const RoundContainer = styled.div`
  border-radius: 50%;
  overflow: hidden;
`;

const BioHeader = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0rem;
  padding-bottom: .5rem;
  strong {
      display:contents !important;
  }
`;

const BioTitle = styled.h2`
  margin-top: 1.3rem;
    color: var(--dark);

`;

export default IndexHeader
